document.getElementById('copyright-year').innerText = new Date().getFullYear().toString();